<template>
  <BasePanel headline="lang_LABEL_TRACKS_CAPTION_MEDIA" :alvqa="alvqa">
    <template v-slot:panelContent>
      <v-data-table
        :headers="headers"
        :items="listItems"
        hide-default-footer
        :header-props="{ sortIcon: '' }"
        :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
        class="noMinWidth"
      >
        <!-- TOP SLOT -->
        <template v-slot:top>
          <v-row class="pb-3">
            <v-spacer></v-spacer>
            <v-col cols="3">
              <BaseButton
                @click="openMediaUploader()"
                :disabled="$route.params.alvId === 'new'"
                label="lang_GENERAL_BUTTON_ADD_ROW"
                block
                :alvqa="alvqa + '-button-add-row'"
              />
            </v-col>
          </v-row>
        </template>

        <!-- Headers -->
        <template
          v-for="(header, i) in headers"
          v-slot:[`header.${header.value}`]
        >
          <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
        </template>

        <template v-slot:[`item.mediaPreviewCoverImage`]="item">
          <div
            v-if="
              ['jpeg', 'jpg', 'png'].includes(item.item.type) && item.item.link
            "
          >
            <v-img
              :alvqa="`${alvqa}-list-row-${item.item.alvId}-icon-play`"
              :src="item.item.link"
              width="40px"
            ></v-img>
          </div>

          <BaseIcon
            v-if="['wav', 'mp3'].includes(item.item.type)"
            @click.stop="play(item.item)"
            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-audio'"
            :icon="item.item.isPlaying ? 'fa-stop-circle' : 'fa-play-circle'"
            :tooltipText="
              item.item.isPlaying
                ? 'lang_GENERAL_CAPTION_STOP'
                : 'lang_GENERAL_CAPTION_PLAY'
            "
          />
          <BaseIcon
            v-if="['pdf', 'zip'].includes(item.item.type)"
            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-audio'"
            :icon="item.item.type === 'pdf' ? 'fa-file-pdf' : 'fas fa-file-archive'"

        />
        </template>

        <!-- Items -->
        <template v-slot:[`item.media`]="item">
          <div :alvqa="alvqa + '-list-row-text-media'">
            {{ item.item.name }}
          </div>
        </template>

        <!-- <template v-slot:[`item.type`]="item"> -->
        <template v-slot:[`item.type`]="item">
          <div :alvqa="alvqa + '-list-row-text-media'">
            {{ item.item.type.toUpperCase() }}
          </div>
        </template>

        <template v-slot:[`item.delete`]="item">
          <!-- Get path from BE -->
          <BaseIcon
            :alvqa="alvqa + '-list-row-icon-donwload'"
            icon="delete"
            tooltipText="lang_GENERIC_CAPTION_DELETE"
            @click="deleteFile(item)"
          />
        </template>
        <template v-slot:[`item.downloadLink`]="{ item }">
           <!-- Get path from BE -->
            <BaseIcon 
              alvqa="alvqa + '-list-row-icon-donwload'"                        
              icon="cloud_download"
              tooltipText="lang_GENERAL_CAPTION_ICON_DOWNLOAD"
              @click.stop="downloadFile(item.link)"
        />
        </template>

      </v-data-table>
    </template>
  </BasePanel>
</template>

<script>
import BasePanel from "@/components/_base/BasePanel";
import BaseIcon from "@/components/_buttons/BaseIcon";
import BaseButton from "@/components/_buttons/BaseButton";
import BaseCheckbox from "@/components/_base/BaseCheckbox";
import api from '@/api_alv'

export default {
  name: "PublishingContractsMediaEditPanel",

  components: {
    BasePanel,
    BaseIcon,
    BaseButton,
    BaseCheckbox,
  },

  data() {
    return {
      alvqa: "contracts-publishing-edit-form-panel-media",
      context: "PublishingContractsMedia",
    };
  },

  computed: {
    headers() {
      return [
        {
          text: "",
          value: "mediaPreviewCoverImage",
          align: "center",
          width: "65px",
          class: "text-no-wrap",
        },
        {
          text: this.$t("lang_LABEL_SALES_DATA_CAPTION_FILE_NAME"),
          align: "left",
          value: "media",
          class: "text-no-wrap",
          sortable: false,
          alvqa: this.alvqa + "-header-artist",
        },
        {
          text: this.$t("lang_GENERIC_CAPTION_TYPE"),
          align: "left",
          value: "type",
          class: "text-no-wrap",
          sortable: false,
          alvqa: this.alvqa + "-header-artist",
        },
        {
          text: "",
          align: "right",
          value: "downloadLink",
          sortable: false,
          width: "70px",
          class: "text-no-wrap",
        },
        {
          text: "",
          align: "right",
          value: "delete",
          sortable: false,
          width: "70px",
          class: "text-no-wrap",
        },
      ];
    },

    listItems() {
      return this.$store.getters.getPublishingContractsMedia;
    },
    globalAudio: {
      get() {
        return this.$store.getters["getAudio"];
      },
      set(item) {
        this.$store.commit("setAudio", item);
      },
    },
  },

  methods: {
    downloadFile(path) {
       api.getFileFromALV(path)
    },
    play(item) {
      // if audio is playing but not clicked one
      // stop playing and set isPlaying property for found track to false
      if (this.globalAudio != null && !item.isPlaying) {
        this.globalAudio.pause();
        this.globalAudio = null;
        let index = this.listItems.findIndex(
          (track) => track.isPlaying === true
        );
        this.listItems[index].isPlaying = false;
      }

      // if audio is not playing (null)
      // create, add event, change isPlaying to true and play audio
      // else
      // pause current track, set global property to null and change isPlaying
      if (this.globalAudio == null) {
        this.globalAudio = new Audio(item.link);
        this.globalAudio.addEventListener(
          "ended",
          this.endedAudioEvent.bind(event, item)
        );
        item.isPlaying = true;
        this.globalAudio.play();
      } else {
        this.globalAudio.pause();
        item.isPlaying = false;
        this.globalAudio = null;
      }
    },
    endedAudioEvent(item) {
      item.isPlaying = false;
      this.globalAudio = null;
    },
    openMediaUploader() {
      this.$store.commit("setShowMediaFileUploadDialog", true);
    },
    deleteFile(item) {
      //DElete call
      this.$store.commit("setSelectedPublishingContractsMediaFiles", [item.item])
      this.$store.commit('setDeletionDialogContext', 'SelectedPublishingContractsMediaFiles')
      this.$store.commit('setShowDeletionDialog', true)
    },
  },
};
</script>

<style></style>
